import React from 'react';
import { BriefcaseIcon } from 'lucide-react';
export const BusinessLicensingWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-1918">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-1919">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-1920">
          <BriefcaseIcon className="h-5 w-5 text-purple-500 mr-2" data-id="element-1921" />
          Business Licensing
        </h2>
      </div>
      <div className="p-6" data-id="element-1922">
        <div className="flex flex-col space-y-4" data-id="element-1923">
          <div className="flex justify-between items-center" data-id="element-1924">
            <span className="text-sm text-gray-600" data-id="element-1925">
              New License Applications
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1926">
              9
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1927">
            <span className="text-sm text-gray-600" data-id="element-1928">
              Licenses Expiring Soon
            </span>
            <span className="bg-orange-100 text-orange-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1929">
              14
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-1930">
            <span className="text-sm text-gray-600" data-id="element-1931">
              Pending Health Inspections
            </span>
            <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-1932">
              6
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-1933">
            <p className="text-xs text-gray-700 font-medium" data-id="element-1934">
              Recent Approvals
            </p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-1935">
              <p data-id="element-1936">• Downtown Café - Food Service</p>
              <p data-id="element-1937">• Smith Contracting - General Contractor</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-1938">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1939">
          View Applications
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-1940">
          Search Businesses
        </a>
      </div>
    </div>;
};